import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
   PickUpStatus,
   StoragePageTab,
   SupplierOrdersPageTab,
   SupplierPalletsPickUpsTab,
} from 'interfaces';

export const useTabs = () => {
   const { t } = useTranslation();

   const supplierOrdersPageTabs: { label: string; value: SupplierOrdersPageTab }[] = useMemo(
      () => [
         { label: t('tabs.orders.all'), value: 'ALL' },
         { label: t('order.status.waiting'), value: 'WAITING' },
         { label: t('order.status.in_progress'), value: 'IN_PROGRESS' },
         { label: t('order.status.delivered'), value: 'DELIVERED' },
         { label: t('order.status.during_billing'), value: 'DURING_BILLING' },
         { label: t('order.status.to_pay'), value: 'TO_PAY' },
         { label: t('tabs.orders.archived'), value: 'ARCHIVED' },
      ],
      [t],
   );

   const storagePageTabs: { label: string; value: StoragePageTab }[] = useMemo(
      () => [
         { label: t('storage_type_labels.internal'), value: 'internal-storages' },
         { label: t('storage_type_labels.external'), value: 'external-storages' },
         { label: t('storage_type_labels.commercial_network'), value: 'commercial-networks' },
         { label: t('nav.supplier_clients'), value: 'clients' },
      ],
      [t],
   );

   const supplierPalletsPickUpsPageTabs: { label: string; value: SupplierPalletsPickUpsTab }[] =
      useMemo(
         () => [
            { label: t('supplier_pickups.table.to_collect'), value: PickUpStatus.CREATED },
            { label: t('pickup_statuses.accepted'), value: PickUpStatus.ACCEPTED },
            { label: t('report_statuses.canceled'), value: PickUpStatus.REJECTED },
         ],
         [t],
      );

   return {
      supplierOrdersPageTabs,
      storagePageTabs,
      supplierPalletsPickUpsPageTabs,
   };
};
